import { AxiosInstance } from "axios"
import { ShippingGenericResponse } from "."

export interface printAwbModel {
    id: string
}

const shippingApi = (apiInstance: AxiosInstance) => {
    const printAwb = async (data: printAwbModel): Promise<ShippingGenericResponse> => {
        const res: Promise<ShippingGenericResponse> = apiInstance.get(`/parcel/awb/` + data.id)
        return res
    }

    const generateShippingLabel = async (data: printAwbModel): Promise<any> => {
        const addParcelDetail = apiInstance.post("/shipment-label/generate-by/" + data.id)
        return addParcelDetail
    }

    return {
        printAwb,
        generateShippingLabel
    }
}

export default shippingApi
